module.exports = __webpack_public_path__ + "static/media/close.a35f019a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/artist-ui/components/Image/close.svg
// module id = 406
// module chunks = 0